<template>
    <div class="clicks-btn">
        <p>Button clicked <b>{{this.$store.state.count}}</b> times</p>
        <v-btn
            @click="increment"
            elevation="2"
        >Click me!</v-btn>
        <p>This button uses state</p>
    </div>
</template>

<script>
export default {
  name: 'ClickComponent',
  methods: {
    increment () {
      this.$store.commit('increment')
    }
  }
}
</script>

<style lang="scss">
.clicks-btn {
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  button {
    background-color: transparent;
    border: none;
    font-size: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ClickComponent.vue